module.exports = __webpack_public_path__ + "static/img/header_logo.26168e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_logo.png
// module id = oHgo
// module chunks = 3